"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTextComponentParameters = void 0;
exports.UserTextComponentParameters = [
    {
        id: 'type',
        label: 'Keyboard Type',
        description: 'Input Param - Type of keyboard shown to the user',
        type: 'enum',
        paramType: 'ENUM',
        list: {
            TEXT: 'Full Text',
            INTEGER: 'Numbers Only',
            FLOAT: 'Numbers with Decimal Point',
        },
        required: false,
    },
    {
        id: 'min_length',
        label: 'Minimum Length',
        description: 'Input Param - Minimum number of characters entered by user',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max_length',
        label: 'Maximum Length',
        description: 'Input Param - Maximum number of words entered by user',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'min',
        label: 'Minimum Value',
        description: 'Input Param - Minimum value allowed',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max',
        label: 'Maximum Value',
        description: 'Input Param - Maximum value allowed',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'full_screen',
        label: 'Full Screen',
        description: 'Input Param - Make the component a full screen text editor',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'pre_fill',
        label: 'Prefill Text',
        description: 'Input Param - Prefill the text box with this value',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'regularExpression',
        label: 'Regular Expression',
        description: 'Input Param - Regular expression to validate the input',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'regexMismatchError',
        label: 'Regex Mismatch Error',
        description: 'Input Param - Error message to display when regex mismatch',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'text',
        label: 'Text Output',
        description: 'Output Param - Text entered by the user',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
];
//# sourceMappingURL=UserTextComponent.js.map